"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
__exportStar(require("@spt-tracking/pulse-sdk-core"), exports);
const pulse_sdk_core_1 = __importDefault(require("@spt-tracking/pulse-sdk-core"));
const collectorEndpoints = {
    dev: 'https://collector.pulse-internal-dev.schibsted.io',
    pre: 'https://collector.pulse-internal-pre.schibsted.io',
    pro: 'https://dc.schibsted.io',
};
const CISEndpoints = {
    dev: 'https://cis.pulse-internal-dev.schibsted.io',
    pre: 'https://cis.pulse-internal-pre.schibsted.io',
    pro: 'https://ncis.schibsted.com',
};
const remoteConfig = {
    dev: 'https://sdkconfig.pulse-internal-dev.schibsted.io/js/config.json',
    pre: 'https://sdkconfig.pulse-internal-pre.schibsted.io/js/config.json',
    pro: 'https://sdkconfig.pulse.schibsted.io/js/config.json',
};
class Tracker extends pulse_sdk_core_1.default {
    constructor(provider, input, builders) {
        const deployStage = (input === null || input === void 0 ? void 0 : input.deployStage) || 'pro';
        super(provider, Object.assign({ remoteConfigurationUrl: remoteConfig[deployStage], fallbackCisBaseUrl: CISEndpoints[deployStage], fallbackCollectorBaseUrl: collectorEndpoints[deployStage], schemaLocation: 'schema.schibsted.com' }, input), builders);
    }
}
exports.Tracker = Tracker;
exports.default = Tracker;
//# sourceMappingURL=index.js.map